<template>
  <v-form>
    <v-select @change="onScenarioSelected($event)" prepend-icon="mdi-checkerboard" :items="scenarios" item-value="id" v-model="form.scenario.id" label="Scenario" solo clearable>
      <template slot="selection" slot-scope="data"> {{ data.item.type }} - {{ data.item.sc_name }} </template>
      <template slot="item" slot-scope="data"> {{ data.item.type }} - {{ data.item.sc_name }} </template>
    </v-select>
    <v-select
      v-if="displaySelectParty"
      @change="onGameSelected($event)"
      prepend-icon="mdi-google-controller"
      :items="games"
      item-text="name"
      item-value="id"
      v-model="form.game.id"
      label="Partie"
      solo
      clearable
      :disabled="games.length <= 0"
    />
    <v-combobox
      v-if="displaySelectTeam"
      v-model="form.team"
      prepend-icon="mdi-account-group"
      item-value="id"
      item-text="name"
      :rules="[() => (form.team && !!form.team.name) || 'This field is required', (value) => (value && value.name.length >= 5) || 'Min 5 characters']"
      :items="teams"
      label="Nom de l'équipe"
      placeholder="Nom de l'équipe"
      required
      solo
      clearable
      @update:search-input="updateTeamName"
    />
    <!--<input type="checkbox" id="useGoogleHome" v-model="form.useGoogleHome" v-if="selectedScenario.type != 'btob'"/>
        <label for="useGoogleHome">Google Home</label>-->
  </v-form>
</template>

<script>
  export default {
    name: 'HomeForm',
    props: {
      form: {
        type: Object,
        default: () => ({
          scenario: {},
          game: {},
          team: undefined,
          useGoogleHome: false,
        }),
        required: true,
      },
    },
    data: () => ({
      scenarios: [],
      games: [],
      teams: [],
    }),
    computed: {
      displaySelectParty: function () {
        return this.form.scenario.id
      },
      displaySelectTeam: function () {
        return this.form.scenario.id && this.form.game.id && this.form.scenario && this.form.scenario.type === 'btob' && SAPIO.User.instance.id !== this.form.game.user_id
      }
    },
    watch: {
      form: {
        handler(newValue) {
          if (this.games.find((e) => e.id === newValue.game.id) === undefined && Object.keys(newValue.game).length !== 0) {
            this.games.push(newValue.game)
          }
        },
        deep: true,
      },
    },
    created() {
      this.loadScenarios()
    },
    methods: {
      loadScenarios() {
        SAPIO.Loader.instance
          .loadScenarios()
          .then((response) => {
            this.scenarios = response
            this.$notify({ group: 'app', type: 'info', title: 'Scénario disponibles chargés !', text: 'Veuillez sélectionner un scénario.' })
          })
          .catch((e) => {
            this.scenarios = []
            this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du chargement des scénarios', text: e.message })
            console.error(e)
          })
      },
      loadGames() {
        SAPIO.Loader.instance
          .loadGamesOnScenario(this.form.scenario.id)
          .then((response) => {
            this.games = response.map(el => Object.assign(el, {name: el.name + ( SAPIO.User.instance.id === el.user_id && this.form.scenario.type === "btob" ? " - MASTER" : "")}))
            if (this.games.length > 0) this.$notify({ group: 'app', type: 'info', title: 'Parties en cours chargées !', text: 'Veuillez sélectionner une partie.' })
            else this.$notify({ group: 'app', type: 'info', title: 'Aucune partie disponible', text: 'Veuillez créer une partie.' })
          })
          .catch((e) => {
            this.games = []
            this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du chargement des parties', text: e.message })
            console.error(e)
          })
      },
      loadTeams() {
        SAPIO.Loader.instance
          .loadTeamsOnGame(this.form.game.id)
          .then((response) => {
            this.teams = response
            if (this.teams.length > 0) this.$notify({ group: 'app', type: 'info', title: 'Equipe chargées !', text: 'Veuillez sélectionner ou créer une équipe.' })
            else this.$notify({ group: 'app', type: 'info', title: 'Aucune équipe disponible', text: 'Veuillez créer une équipe.' })
          })
          .catch((e) => {
            this.teams = []
            this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du chargement des équipes', text: e.message })
            console.error(e)
          })
      },
      onScenarioSelected(event) {
        var json = this.scenarios.find((e) => e.id === event)
        json = {...JSON.parse(json.json_data), ...json}
        delete json.json_data
        this.form.scenario = event ? SAPIO.Scenario.createFromJson(json) : {}
        SAPIO.Scenario.instance.LS_SAVE()
        this.form.game = {}
        this.form.team = undefined
        this.loadGames()
      },
      onGameSelected(event) {
        var json = this.games.find((e) => e.id === event)
        json = {...JSON.parse(json.json_data), ...json}
        delete json.json_data
        this.form.game = event ? SAPIO.Game.createFromJson(json) : {}
        SAPIO.Game.instance.LS_SAVE()
        this.form.team = undefined
        if (this.form.scenario.type === 'btob') this.loadTeams()
      },
      updateTeamName(teamName) {
        if (teamName === null) this.form.team = undefined
        else if (this.form.team === undefined && teamName !== null) this.form.team = { name: teamName }
        else if (teamName !== this.form.team.name) this.form.team = { name: teamName }
      },
    },
  }
</script>
